import { orchestrator } from 'satcheljs';
import { onCloseHeaderPane } from 'owa-app-pane-group-actions';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { headerButtons } from '../components/buttons/headerButtons';
import logMissingHeaderButtonPaneError from '../utils/logMissingHeaderButtonPaneError';
import closeHeaderPane from './closeHeaderPane';

orchestrator(onCloseHeaderPane, ({ headerPaneName, targetWindow }) => {
    const paneId = getDrawerPaneId(headerPaneName);
    const headerButton = headerButtons.find(button => button.pane?.id === paneId);

    if (!headerButton) {
        logMissingHeaderButtonPaneError(headerPaneName, paneId);
        return;
    }

    closeHeaderPane(paneId, targetWindow);
});
